import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';

export interface DownloadFileProps {
  fileId: string;
}

export function useDownloadPdfFiles() {
  const { enqueueSnackbar } = useSnackbar();
  const { pdfUploadService } = useService();
  const mutation = useMutation<void, Error, DownloadFileProps>(request => pdfUploadService.downloadPdfFile(request), {
    onError: error => {
      enqueueSnackbar('Could not find file for download', { variant: 'error' });
      console.log('File not downloaded ', error);
    },
  });

  return mutation;
}
